function hasWindow() {
  try {
    return typeof window !== 'undefined';
  } catch {
    return false;
  }
}

export const isBrowser = hasWindow();
export const isServer = !isBrowser;
